import * as PIXI from 'pixi.js-legacy';
window.PIXI = PIXI;
global.PIXI = PIXI;
require('pixi-layers');
import EventEmitter from 'eventemitter3';
import getProviders from '@/ui/apiprovider.js';


function RenderTools(container, layers, canvasSize) {
  this.lol = Math.floor(Math.random() * 1000000);
  EventEmitter.call(this);
  this.container = container;
  this.ticker = new PIXI.Ticker();
  this.ticker.stop();

  this.ticker.add(this.tick.bind(this));

  //this.appTicker = app.ticker;
  //this.appTicker.stop();

  this.enterBatch = [];
  this.updateBatch = [];
  this.exitBatch = [];
  this.runBatch = [];
  this.waitBatch = [];

  this.errors = [];

  this.updateIdSet = new Set();
  this.runIdSet = new Set();

  this.stats = {
    frames:0,

    lastEnterDuration:0,
    lastUpdateDuration:0,
    lastExitDuration:0,
    lastRunDuration:0,
    lastWaitDuration:0,

    lastEnterCount:0,
    lastUpdateCount:0,
    lastExitCount:0,
    lastRunCount:0,
    lastWaitCount:0
  }

  this.busy = false;
  this.loading = false;

  this.layers = layers;
  this.pixiLayers = {};

  this.onReadyEventsQueue = {};
  this.onAutoScaleQueue = {};

  this.canvasSize = canvasSize;

}

RenderTools.prototype = Object.create(EventEmitter.prototype);

RenderTools.prototype.getCanvasSize = function () {
  return this.canvasSize;
}
RenderTools.prototype.updateCanvasSize = function (s) {
  this.canvasSize = s;
}
RenderTools.prototype.setupApp = function (app) {
  this.app = app;

  app.stage = new PIXI.display.Stage();
  app.stage.group.enableSort = true;
  app.stage.sortableChildren = true;

  this.stage = app.stage;
}

RenderTools.prototype.getCanonicalZindex = function (transform) {
  const layer = this.layers[transform.transform.layer];
  return this.getZIndexInLayer(layer, transform.transform.zIndex);
}

RenderTools.prototype.getZIndexInLayer = function (layer, zindex) {
  return layer.zindex * 10000 + zindex; 
}

const DEFAULT_LAYER = 1;
RenderTools.prototype.setZIndex = function (container, layerId, zindex) {
  const layer = this.layers[layerId];
  if (isNaN(zindex)) {
    zindex = DEFAULT_LAYER;
  }
  // TODO: disable this for now as it causes
  // issues with cacheAsBitmap
  //if (zindex === DEFAULT_LAYER) {
    //return zindex;
  //}
  //

  // TODO: hack around the layer groups
  // by assuming a max of 10000 for each layer group
  zindex = this.getZIndexInLayer(layer, zindex);
  if (zindex <= 0) {
    zindex -= 1;
  }
  const pl = this.getLayer(layer);

  container.parentLayer = pl;
  container.sortableChildren = true;
  container.zOrder = zindex;

  return zindex;

}
RenderTools.prototype.tick = function (dt) {
  //if (typeof(max) === 'undefined') {
    //max = 1;
  //}
  let max = 40;
  this.runBatches(max);
}
RenderTools.prototype.destroy = function () {
  this.ticker.stop();
}

RenderTools.prototype.addToEnterBatch = function (h) {
  this.enterBatch.push(h);
  this.checkState();
}
RenderTools.prototype.addToUpdateBatch = function (h, id) {
  if (id) {
    if (this.updateIdSet.has(id)) {
      return;
    }
    this.updateIdSet.add(id);
  }
  this.updateBatch.push(h);
  this.checkState();
}
RenderTools.prototype.addToExitBatch = function (h) {
  this.exitBatch.push(h);
  this.checkState();
}
RenderTools.prototype.addToWaitBatch = function (c) {
  this.waitBatch.push(c);
  this.checkState();
}
RenderTools.prototype.addToRunBatch = function (c, id) {
  if (id) {
    if (this.runIdSet.has(id)) {
      return;
    }
    this.runIdSet.add(id);
  }
  this.runBatch.push(c);
  this.checkState();
}
RenderTools.prototype.runBatches = function (max) {
  let exitsToRun = this.exitBatch.length;
  let runsToRun = this.runBatch.length;
  let waitsToRun = this.waitBatch.length;

  let t1 = new Date().getTime();
  this.runExitBatch(max, exitsToRun);
  let t2 = new Date().getTime();

  max -= (t2-t1)
  this.stats.lastExitDuration += t2 - t1;

  let entersToRun = this.enterBatch.length;
  t1 = new Date().getTime();
  this.runEnterBatch(max, entersToRun);
  t2 = new Date().getTime();

  max -= (t2-t1)
  this.stats.lastEnterDuration += t2 - t1;

  let updatesToRun = this.updateBatch.length;
  t1 = new Date().getTime();
  this.runUpdateBatch(max, updatesToRun);
  t2 = new Date().getTime();

  max -= (t2-t1)
  this.stats.lastUpdateDuration += t2 - t1;

  t1 = new Date().getTime();
  this.runRunBatch(max, runsToRun);
  t2 = new Date().getTime();

  max -= (t2-t1)
  this.stats.lastRunDuration += t2 - t1;

  t1 = new Date().getTime();
  this.runWaitBatch(max, waitsToRun);
  t2 = new Date().getTime();

  max -= (t2-t1)
  this.stats.lastWaitDuration += t2 - t1;

  this.checkState();
  this.stats.frames++;

  if (this.updateIdSet.size) {
    this.updateIdSet.clear();
  }
  if (this.runIdSet.size) {
    this.runIdSet.clear();
  }

}

RenderTools.prototype.executeReadyEvents = function ({id}, holder) {
  (this.onReadyEventsQueue[id]||[]).forEach( (func) => {
    func(holder);
  });
  this.onReadyEventsQueue[id] = [];
}

RenderTools.prototype.executeAutoScaleEvent = function (transform, holder) {
  this.emit('autoscale', transform);
  const {id} = transform;
  (this.onAutoScaleQueue[id]||[]).forEach( (func) => {
    func(holder);
  });
  this.onAutoScaleQueue[id] = [];
}

RenderTools.prototype.addOnAutoScaleEvent = function ({id}, func) {
  if (!this.onAutoScaleQueue[id]) {
    this.onAutoScaleQueue[id] = [];
  }
  this.onAutoScaleQueue[id].push(func);
}
RenderTools.prototype.addOnReadyEvent = function ({id}, func) {
  if (!this.onReadyEventsQueue[id]) {
    this.onReadyEventsQueue[id] = [];
  }
  this.onReadyEventsQueue[id].push(func);
}

RenderTools.prototype.checkState = function () {
  const total = this.enterBatch.length + this.exitBatch.length + this.waitBatch.length + this.runBatch.length + this.updateBatch.length;
  const loading = this.enterBatch.length + this.waitBatch.length;
  if (total > 0) {
    this.emit('update');
    if (!this.busy || !this.loading) {
      this.busy = true;
      this.ticker.start();
      if (!this.loading && loading > 0) {
        this.emit('start');
        this.loading = true;
      }
    }
  } else {
    if (this.busy) {
      this.busy = false;
      this.ticker.stop();
      if (this.loading) {
        this.emit('stop');
        this.loading = false;
      }
    }
  }

}

RenderTools.prototype.setStageInteractive = function (stageInteractive) {
  this.stageInteractive = stageInteractive;
}
RenderTools.prototype.runUpdateBatch = function (max, total) {
  if (max <= 0) {
    return
  }
  const updateBatch = this.updateBatch;
  if (updateBatch.length === 0) {
    return;
  }
  const startTime = new Date().getTime();
  let i = 0;
  while ( i < total && (new Date().getTime()) - startTime < max) {
    try {
      const toUpdate = updateBatch[i];
      if (!toUpdate) {
        continue;
      }
      this.stats.lastUpdateCount++;
      i++;
      toUpdate.update();
    } catch (e) {
      console.error(e);
      break;
    }
  }
  updateBatch.splice(0, i)
}

RenderTools.prototype.runEnterBatch = function (max, total) {
  if (max <= 0) {
    return
  }
  const enterBatch = this.enterBatch;
  if (enterBatch.length === 0) {
    return;
  }
  const startTime = new Date().getTime();
  let i = 0;
  while ( i < total && (new Date().getTime()) - startTime < max) {
    try {
      const toEnter = enterBatch[i];
      if (!toEnter) {
        continue;
      }
      i++;
      this.stats.lastEnterCount++;
      toEnter.enter();
      //toEnter.update();
    } catch (e) {
      console.error(e);
      break;
    }
  }
  enterBatch.splice(0, i)

}
RenderTools.prototype.runExitBatch = function (max, total) {
  if (max <= 0) {
    return
  }
  const exitBatch = this.exitBatch;
  if (exitBatch.length === 0) {
    return;
  }

  const startTime = new Date().getTime();
  let i = 0;
  while ( i < total && (new Date().getTime()) - startTime < max) {
    try {
      const toExit = exitBatch[i];
      if (!toExit) {
        continue;
      }
      i++;
      this.stats.lastExitCount++;
      toExit.exit();
    } catch (e) {
      console.error(e);
      break;
    }
  }

  exitBatch.splice(0, i)
}
RenderTools.prototype.runWaitBatch = function (max, total) {
  if (max <= 0) {
    return
  }
  const waitBatch = this.waitBatch;
  if (waitBatch.length === 0) {
    return;
  }
  const startTime = new Date().getTime();
  let i = 0;
  while ( i < total && (new Date().getTime()) - startTime < max) {
    try {
      waitBatch[i]();
      i++;
      this.stats.lastWaitCount++;
    } catch (e) {
      i++;
      console.error(e);
      break;
    }
  }
  waitBatch.splice(0, i)
  //enterBatch.slice(0,1).forEach( (toEnter,i) => {
    //toEnter.enter();
    //toEnter.update();
    //toRemove.push(i);
  //});
};
RenderTools.prototype.runRunBatch = function (max, total) {
  if (max <= 0) {
    return
  }
  const runBatch = this.runBatch;
  if (runBatch.length === 0) {
    return;
  }
  const startTime = new Date().getTime();
  let i = 0;
  while ( i < total && (new Date().getTime()) - startTime < max) {
    try {
      runBatch[i]();
      i++;
      this.stats.lastRunCount++;
    } catch (e) {
      i++;
      console.error(e);
      break;
    }
  }
  runBatch.splice(0, i)
}


RenderTools.prototype.makeImageUrl = function (img) {
  return getProviders().api.makeImageUrl(img);
}
RenderTools.prototype.makeThumbnailUrl= function (img) {
  return getProviders().api.makeThumbnailUrl(img);
}

RenderTools.prototype.makeSpritesheetUrl = function (img) {
  return getProviders().api.makeSpritesheetUrl(img);
}

RenderTools.prototype.getLayer = function (in_layer) {
  if (!this.pixiLayers[in_layer.zindex]) {
    const layerGroup = new PIXI.display.Group(in_layer.zindex);
    layerGroup.enableSort = true;
    const layer = new PIXI.display.Layer(layerGroup);
    layerGroup.sortableChildren = true;
    this.pixiLayers[in_layer.zindex] = {
      layerGroup,
      layer,
      count:0
    }
    this.app.stage.addChild(layer);
  }
  this.pixiLayers[in_layer.zindex].count++;
  return this.pixiLayers[in_layer.zindex].layer;

  //return new PIXI.display.Group(n);
}

const X_RATIO = 1920/16;
const Y_RATIO = 1080/9;
//const X_RATIO = 1;
//const Y_RATIO = 1;
RenderTools.prototype.worldToScreen = function (p) {
  return {
    x:p.x * X_RATIO,
    y:p.y * Y_RATIO
  }
}
RenderTools.prototype.worldToScreen_x = function (x) {
  return x * X_RATIO;
}
RenderTools.prototype.worldToScreen_y = function (y) {
  return y * Y_RATIO;
}
RenderTools.prototype.centerThing = function (p) {
  const pos = this.container.worldTransform.apply(p);
  return pos;
}
RenderTools.prototype.worldToScreenScaled = function (p) {
  let {x,y} = this.worldToScreen(p);
  x *= (this.stage.scale.x * this.container.scale.x);
  y *= (this.stage.scale.y * this.container.scale.y);
  return {
    x,
    y
  }
}
RenderTools.prototype.worldToScreenScaled_x = function (x) {
  return this.worldToScreenScaled({x,y:0}).x;
}
RenderTools.prototype.worldToScreenScaled_y = function (y) {
  return this.worldToScreenScaled({x:0,y}).y;
}
RenderTools.prototype.screenToWorld = function (p) {
  return {
    x:p.x / X_RATIO,
    y:p.y / Y_RATIO
  }
}
RenderTools.prototype.screenToWorld_x = function (x) {
  return x / X_RATIO;
}
RenderTools.prototype.screenToWorld_y = function (y) {
  return y / Y_RATIO;
}

RenderTools.prototype.screenToWorldWithOffset = function ({x,y}) {
  x -= this.stage.position.x;
  y -= this.stage.position.y;
  const pos = this.screenToWorld({x,y});
  pos.x /= this.stage.scale.x;
  pos.y /= this.stage.scale.y;

  pos.x += this.screenToWorld_x(this.stage.pivot.x);
  pos.y += this.screenToWorld_x(this.stage.pivot.y);

  return pos;
}

RenderTools.prototype.screenToWorld2 = function ({x,y}) {
  return this.stage.localTransform.apply({x,y});
}

RenderTools.prototype.convertWidthAndHeightToWorld = function (width, height) {
  const bb = this.screenToWorld({x:width,y:height});
  //console.log('STATE SCALE', this.stage.scale.x, this.stage.scale.y);
  //bb.x /= this.stage.scale.x;
  //bb.y /= this.stage.scale.y;
  return {
    width:bb.x,
    height:bb.y
  }
}
RenderTools.prototype.getWorldSize = function (container) {
  const b = container.getBounds();
  const bb = this.screenToWorld({x:b.width,y:b.height});
  bb.x /= this.stage.scale.x;
  bb.y /= this.stage.scale.y;
  return {
    width:bb.x,
    height:bb.y
  }
}

RenderTools.prototype.getCenter = function () {
  return this.stage.pivot;
}
RenderTools.prototype.getBlockSize = function () {
  const unit = this.worldToScreenScaled({x:1,y:1});
  return unit;
}
RenderTools.prototype.getScreenCanvasCenterPoint = function () {
  const stage = this.stage;
  const view = this.app.view;
  const pivot = stage.pivot;
  const boundingBox = view.getBoundingClientRect();
  const center = {
    x:boundingBox.width/2,
    //y:boundingBox.height/2
    //y:pivot.y * stage.scale.y
    y:boundingBox.height/2
  }

  center.x += pivot.x * stage.scale.x;
  center.y += pivot.y * stage.scale.y;
  return center;

}

RenderTools.prototype.addError = function (transform, err) {
  const {id} = transform.id
  this.errors.push({
    id,
    err
  });
}

RenderTools.prototype.clearStats = function () {
  this.stats.lastEnterDuration=0;
  this.stats.lastUpdateDuration=0;
  this.stats.lastExitDuration=0;
  this.stats.lastRunDuration=0;
  this.stats.lastWaitDuration=0;

  this.stats.lastEnterCount=0;
  this.stats.lastUpdateCount=0;
  this.stats.lastExitCount=0;
  this.stats.lastRunCount=0;
  this.stats.lastWaitCount=0;

  this.stats.frames = 0;
}

RenderTools.prototype.generateTexture = function (displayObject, scaleMode, resolution, region) {
  return this.app.renderer.generateTexture(displayObject, scaleMode, resolution);
}

RenderTools.prototype.getWorldPosition = function (container, p) {
  const pivot = this.stage.pivot;
  let pos;
  if (container.getWorldTransform) {
    pos = container.getWorldTransform().apply(p);
  } else {
    pos = container.worldTransform.apply(p);
  }
  //pos.x += pivot.x;
  //pos.y += pivot.y;
  pos = this.stage.localTransform.applyInverse(pos);

  const worldPos = {
    x:this.screenToWorld_x(pos.x),
    y:this.screenToWorld_y(pos.y),
  }
  return worldPos;
}

function round(p, n) {
  return (p % n < n / 2 ? p - (p % n) : p + n - (p % n));
}

RenderTools.prototype.snapToGrid = function ({position,grid}) {
  return {
    x:round(position.x, grid.x),
    y:round(position.y - grid.y/2, grid.y)
  }
}


export default RenderTools;
